module.exports = __webpack_public_path__ + "static/media/b3.382caa4a.png";